"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
function ConversationalQuoteForm() {
  return <div className="py-16 px-4 bg-[hsl(210,12%,97%)]">
      <div className="max-w-3xl mx-auto text-center">
        <div className="bg-white rounded-lg shadow-medium p-12 border border-[hsl(210,12%,80%)]">
          <div className="w-16 h-16 bg-[hsl(35,94%,53%)] rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h2 className="text-3xl font-display font-bold text-[hsl(0,0%,12%)] mb-4">
            Obtenez Votre Devis Gratuit en 3 Minutes
          </h2>
          <p className="text-[hsl(0,0%,12%)]/70 text-lg mb-8 leading-relaxed">
            Rénovation énergétique, petits travaux ou grands chantiers : comparez jusqu'à 5 devis d'artisans qualifiés près de chez vous. Service 100% gratuit et sans engagement.
          </p>
          
          <div className="bg-[hsl(210,12%,97%)] rounded-lg p-6 mb-8 text-left">
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <svg className="w-6 h-6 text-[hsl(215,90%,56%)] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-[hsl(0,0%,12%)]/80"><strong className="text-[hsl(0,0%,12%)]">Artisans certifiés RGE</strong> pour vos travaux de rénovation énergétique</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-6 h-6 text-[hsl(215,90%,56%)] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-[hsl(0,0%,12%)]/80"><strong className="text-[hsl(0,0%,12%)]">Devis comparatifs</strong> détaillés en moins de 48 heures</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-6 h-6 text-[hsl(215,90%,56%)] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-[hsl(0,0%,12%)]/80"><strong className="text-[hsl(0,0%,12%)]">Information sur les aides financières</strong> MaPrimeRénov', CEE et primes locales</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-6 h-6 text-[hsl(215,90%,56%)] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-[hsl(0,0%,12%)]/80"><strong className="text-[hsl(0,0%,12%)]">Accompagnement personnalisé</strong> de votre projet de A à Z</span>
              </li>
            </ul>
          </div>

          <Link to="https://betravaux.com/#devis">
            <Button variant="secondary" className="bg-[hsl(35,94%,53%)] hover:bg-[hsl(35,90%,60%)] text-white shadow-xs btn-quote">
              Demander Mon Devis Gratuit
            </Button>
          </Link>
          
          <p className="text-sm text-[hsl(0,0%,12%)]/60 mt-6">
            Plus de 50 000 particuliers nous ont fait confiance pour leurs travaux de rénovation
          </p>
        </div>
      </div>
    </div>;
}
export default ConversationalQuoteForm;